import { Component, OnInit } from '@angular/core';

import { FormArray, FormGroup } from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { RelativeDateService } from '@library/common/datehandler';
import { ReportDetailsService } from '../../report.details.service';
import { ReportEnumsService } from '../../report.enums.service';

import { ReportColumn } from '../../report';
import { filterGroup } from '../../report.group';

@UntilDestroy()
@Component({
   selector: 'lib-report-filters',
   templateUrl: './filters.component.html',
   styleUrls: ['./filters.component.scss'],
   outputs: [ 'valid' ],
})
export class FiltersComponent implements OnInit {

   filters: FormArray = this.report.reportForm.get( 'filters' ) as FormArray;

   get valid() {
      if ( !this.columns.size ) { return true; }

      return this.filters.length > 0 && this.filters.valid;
   }

   columns: Map<string, ReportColumn> = new Map();

   available$: BehaviorSubject<ReportColumn[]> = new BehaviorSubject( [] );

   _loading = true;

   constructor(
      public report: ReportDetailsService,
      public reportEnums: ReportEnumsService,
      public rdate: RelativeDateService,
   ) { }

   ngOnInit(): void {
      this.filters.valueChanges.pipe(
         map( filters => {
            const names = filters.map( f => f.name );

            return [ ...this.columns.keys() ].filter( key => names.indexOf( key ) === -1 )
               .map( key => this.columns.get( key ));
         }),
         untilDestroyed( this ),
      ).subscribe( filters => this.available$.next( filters ));

      this.report.columns.pipe(
         map( columns => columns.filter( c => c.filters )),
         map( columns => columns.sort(( a, b ) => ( a?.sort_order ?? 0 ) - ( b?.sort_order ?? 0 ))),
         untilDestroyed( this ),
      ).subscribe( columns => {
         columns.map( c => this.columns.set( c.name, c ));
         this._loading = false;
         this.filters.updateValueAndValidity();
      });
   }

   add( column: ReportColumn ): void {
      const defaultValue = type => {
         switch ( type.toLowerCase() ) {
            case 'boolean': return false;
            case 'date':    return new Date();
            case 'number':  return 0;
            default:        return '';
         }
      };

      this.filters.push( filterGroup({
         name: column.name,
         value: defaultValue( column.type ),
      }));
   }

   toggleRelativeDate( filter: FormGroup ) {
      filter.get( 'relative' ).setValue( !filter.get( 'relative' ).value );
   }
}
